import { AccountStatementActionTypes, AccountStatementAction, AccountStatementState } from '../../types/accountsStatement';

const initialState = {
  accountsStatementData: {},
  inProgress: false,
  filterData: [],
  ccyName: {},
  blocksByIban: [],
  inProgressAccounts: false,
  accountsData: [],
  moreDetailData: {},
  ibanNumber: {},
  requisiteData: {},
  accountLoading: false,
  balanceLoading: false,
  transferWidgetLoading: false,
}
const accountStatementReducer = (state = initialState, action: AccountStatementAction): AccountStatementState => {
  switch (action.type) {
    case AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_REQUEST:
      return {
        ...state,
        inProgress: true,
      }
    case AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_SUCCESS:
      return {
        ...state,
        accountsStatementData: action.payload,
        inProgress: false,
      }
    case AccountStatementActionTypes.GET_ACCOUNTS_STATEMENT_ERROR:
      return {
        ...state,
        notify: false,
        inProgress: false
      }

    case AccountStatementActionTypes.SET_ACCOUNTS_STATEMENT_FILTER:
      return {
        ...state,
        filterData: action.payload
      }

    case AccountStatementActionTypes.SET_CCY_NAME:
      return {
        ...state,
        ccyName: action.payload
      }

    case AccountStatementActionTypes.GET_BLOCKED_IBAN_REQUEST:
      return {
        ...state,
        inProgress: true,
      }
    case AccountStatementActionTypes.GET_BLOCKED_IBAN_SUCCESS:
      return {
        ...state,
        blocksByIban: action.payload,
        inProgress: false,
      }
    case AccountStatementActionTypes.GET_BLOCKED_IBAN_ERROR:
      return {
        ...state,
        notify: false,
        inProgress: false
      }

    case AccountStatementActionTypes.GET_ACCOUNTS_DATA_REQUEST:

      return {
        ...state,
        inProgressAccounts: true,
      }
    case AccountStatementActionTypes.GET_ACCOUNTS_DATA_SUCCESS:

      return {
        ...state,
        accountsData: action.payload.result,
        inProgressAccounts: false,
      }
    case AccountStatementActionTypes.GET_ACCOUNTS_DATA_ERROR:
      return {
        ...state,
        notify: false,
        inProgressAccounts: false,
      }

    case AccountStatementActionTypes.SET_MORE_DETAIL:
      return {
        ...state,
        moreDetailData: action.payload
      }

    case AccountStatementActionTypes.SET_IBAN_NUMBER:
      return {
        ...state,
        ibanNumber: action.payload
      }

    case AccountStatementActionTypes.GET_REQUISITE_REQUEST:
      return {
        ...state,
        inProgress: true,
        requisiteData: [],
      }
    case AccountStatementActionTypes.GET_REQUISITE_SUCCESS:
      return {
        ...state,
        requisiteData: action.payload,
        inProgress: false,
      }
    case AccountStatementActionTypes.GET_REQUISITE_ERROR:
      return {
        ...state,
        notify: false,
        inProgress: false
      }
    case AccountStatementActionTypes.SET_ACCOUNT_LOADING:
      return {
        ...state,
        accountLoading: action.payload
      }
    case AccountStatementActionTypes.SET_BALANCE_LOADING:
      return {
        ...state,
        balanceLoading: action.payload
      }
    case AccountStatementActionTypes.SET_TRANSFER_WIDGET_LOADING:
      return {
        ...state,
        transferWidgetLoading: action.payload
      }


    default:
      return state;
  }
}
export default accountStatementReducer
